import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Notifications, PortalApiService } from './portal-api.service';
import { AuthService } from '../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private notificationsSubject = new BehaviorSubject<Notifications>(
    new Notifications()
  );
  public notifications$ = this.notificationsSubject.asObservable();

  constructor(private portalApiService: PortalApiService, private authService: AuthService) { }

  getUserNotifications(): void {
    var userInfo = this.authService.getCurrentUser();//.subscribe( x=> userInfo = x);
    if (userInfo && userInfo.profile[this.authService.ACCOUNT_OWNER_ID_CLAIM] != null) {
      this.portalApiService
        .getNotifications()
        .pipe(tap((notification) => {
          this.notificationsSubject.next(notification);
        }))
        .subscribe({
          error: (err) => console.error('Error fetching notifications:', err),
        });
    }
  }

  refreshNotifications(): void {
    this.getUserNotifications();
  }
}
